import React, { useState } from 'react';
import { Video, Calendar, Users, Settings, Search } from 'lucide-react';
import MeetingsList from './zoom/MeetingsList';
import MeetingScheduler from './zoom/MeetingScheduler';
import JoinMeeting from './zoom/JoinMeeting';
import MeetingRecordings from './zoom/MeetingRecordings';
import { useZoomMeetings } from '../../hooks/useZoomMeetings';

export default function ZoomDashboard() {
  const [showScheduler, setShowScheduler] = useState(false);
  const [showJoinDialog, setShowJoinDialog] = useState(false);
  const { meetings, recordings, scheduleMeeting, joinMeeting, startMeeting } = useZoomMeetings();
  const [searchTerm, setSearchTerm] = useState('');

  const handleStartMeeting = () => {
    startMeeting({
      topic: 'Instant Meeting',
      type: 1, // 1 for instant meeting
      duration: 60,
    });
  };

  return (
    <div className="h-full">
      <div className="mb-6">
        <h2 className="text-2xl font-bold text-gray-800">Zoom Meetings</h2>
        <p className="mt-2 text-gray-600">Manage your video conferences</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
        <button 
          onClick={handleStartMeeting}
          className="p-6 bg-blue-600 text-white rounded-xl hover:bg-blue-700 transition-colors"
        >
          <Video className="w-6 h-6 mb-2" />
          <h3 className="text-lg font-medium">Start Instant Meeting</h3>
          <p className="mt-1 text-sm text-blue-100">Start a meeting now</p>
        </button>

        <button 
          onClick={() => setShowScheduler(true)}
          className="p-6 bg-white text-gray-900 rounded-xl border-2 border-dashed border-gray-300 hover:border-blue-500 transition-colors"
        >
          <Calendar className="w-6 h-6 mb-2" />
          <h3 className="text-lg font-medium">Schedule Meeting</h3>
          <p className="mt-1 text-sm text-gray-500">Plan a future meeting</p>
        </button>

        <button 
          onClick={() => setShowJoinDialog(true)}
          className="p-6 bg-white text-gray-900 rounded-xl border-2 border-dashed border-gray-300 hover:border-blue-500 transition-colors"
        >
          <Users className="w-6 h-6 mb-2" />
          <h3 className="text-lg font-medium">Join Meeting</h3>
          <p className="mt-1 text-sm text-gray-500">Join with a meeting ID</p>
        </button>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-white rounded-lg shadow-sm">
          <div className="px-6 py-4 border-b border-gray-200">
            <div className="flex items-center justify-between">
              <h3 className="text-lg font-medium text-gray-900">Upcoming Meetings</h3>
              <div className="relative">
                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" />
                <input
                  type="text"
                  placeholder="Search meetings..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="pl-9 pr-4 py-2 border border-gray-300 rounded-lg text-sm focus:ring-blue-500 focus:border-blue-500"
                />
              </div>
            </div>
          </div>

          <MeetingsList 
            meetings={meetings}
            searchTerm={searchTerm}
            onJoin={joinMeeting}
          />
        </div>

        <MeetingRecordings recordings={recordings} />
      </div>

      {showScheduler && (
        <MeetingScheduler
          onSchedule={scheduleMeeting}
          onClose={() => setShowScheduler(false)}
        />
      )}

      {showJoinDialog && (
        <JoinMeeting
          onJoin={joinMeeting}
          onClose={() => setShowJoinDialog(false)}
        />
      )}
    </div>
  );
}